import React from 'react';
import StarFilledIcon from '@atlaskit/icon/core/star-starred';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

const StarTitleCell = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return <StarFilledIcon label={formatMessage(messages.starred)} />;
};

export default StarTitleCell;
